import React from 'react';
import Icon from '../../../components/AppIcon';

const TierProgressCard = ({ currentTier, nextTier, currentRevenue, nextTierThreshold, orderCount, benefits }) => {
  const progress = (currentRevenue / nextTierThreshold) * 100;
  const remainingRevenue = nextTierThreshold - currentRevenue;

  const getTierColor = (tier) => {
    switch (tier) {
      case 'Bronze':
        return '#CD7F32';
      case 'Silver':
        return '#C0C0C0';
      case 'Gold':
        return '#FFD700';
      case 'Platinum':
        return '#E5E4E2';
      default:
        return 'var(--color-primary)';
    }
  };

  const getTierIcon = (tier) => {
    switch (tier) {
      case 'Bronze':
        return 'Award';
      case 'Silver':
        return 'Medal';
      case 'Gold':
        return 'Trophy';
      case 'Platinum':
        return 'Crown';
      default:
        return 'Star';
    }
  };

  return (
    <div className="bg-gradient-to-br from-primary/10 to-accent/10 rounded-xl shadow-warm p-4 md:p-6">
      <div className="flex items-start justify-between mb-6">
        <div>
          <p className="text-sm md:text-base font-caption text-muted-foreground mb-2">Current Tier</p>
          <div className="flex items-center gap-3">
            <div 
              className="w-12 h-12 md:w-14 md:h-14 rounded-xl flex items-center justify-center"
              style={{ backgroundColor: `${getTierColor(currentTier)}20` }}
            >
              <Icon name={getTierIcon(currentTier)} size={24} color={getTierColor(currentTier)} />
            </div>
            <div>
              <h3 className="text-2xl md:text-3xl font-heading font-bold" style={{ color: getTierColor(currentTier) }}>
                {currentTier}
              </h3>
              <p className="text-sm text-muted-foreground">{orderCount} orders completed</p>
            </div>
          </div>
        </div>
        <div className="text-right">
          <p className="text-sm font-caption text-muted-foreground mb-1">Total Revenue</p>
          <p className="text-xl md:text-2xl font-heading font-bold text-foreground data-text">
            ${currentRevenue?.toLocaleString()}
          </p>
        </div>
      </div>
      <div className="mb-6">
        <div className="flex items-center justify-between mb-2">
          <p className="text-sm font-caption font-semibold text-foreground">
            Progress to {nextTier}
          </p>
          <p className="text-sm font-semibold text-primary data-text">
            {progress?.toFixed(1)}%
          </p>
        </div>
        <div className="w-full h-3 bg-muted rounded-full overflow-hidden">
          <div 
            className="h-full bg-gradient-to-r from-primary to-accent rounded-full transition-all duration-500"
            style={{ width: `${Math.min(progress, 100)}%` }}
          />
        </div>
        <p className="text-xs md:text-sm text-muted-foreground mt-2">
          ${remainingRevenue?.toLocaleString()} more to reach {nextTier} tier
        </p>
      </div>
      <div className="space-y-3">
        <p className="text-sm font-caption font-semibold text-foreground">
          {nextTier} Tier Benefits:
        </p>
        {benefits?.map((benefit, index) => (
          <div key={index} className="flex items-start gap-2">
            <Icon name="CheckCircle" size={16} color="var(--color-success)" className="flex-shrink-0 mt-0.5" />
            <p className="text-sm text-muted-foreground">{benefit}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TierProgressCard;